import React, { useState, useEffect } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ApiContext } from '../../App';


const TestimonialsCarousel = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const API = useContext(ApiContext);
  const [loading, setLoading] = useState(false);
  const [testimonials, setTestimonials] = useState([]);


  // Couleurs dispo pour les avatars
  const colors = [
    "from-blue-500 to-blue-600",
      "from-green-500 to-green-600",
      "from-purple-500 to-purple-600",
      "from-orange-500 to-orange-600",
      "from-red-500 to-red-600",
      "from-indigo-500 to-indigo-600",
      "from-pink-500 to-pink-600",
      "from-teal-500 to-teal-600"
  ]

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      console.log('🔍 Récupération des avis...');
      const response = await API.get('/api/avis');

      if (!response || !response.data) {
        console.error('❌ Pas de données reçues de l\'API');
        setTestimonials([]);
        return;
      }

      console.log('📊 Avis reçus:', response.data);
      const publishedAvis = response.data.filter(avis => avis.isPublished);
      console.log('✅ Avis publiés:', publishedAvis);

      const transformedAvis = publishedAvis.map((avis, index) => ({
        id: avis._id,
        quote: avis.comment,
        author: avis.individual?.Name,
        position: avis.individual?.jobTitle,
        company: avis.individual?.companyId?.name || avis.individual?.company || 'Entreprise',
        avatar: avis.individual?.photo || (avis.individual?.Name ? avis.individual.Name.charAt(0).toUpperCase() : 'U'),
        color: colors[index % colors.length],
        rating: avis.rating,
        isPhoto: !!avis.individual?.photo
      }));
      console.log('🔄 Avis transformés:', transformedAvis);
      setTestimonials(transformedAvis);
    } catch (error) {
      console.error('❌ Erreur lors du chargement des témoignages:', error);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchTestimonials();
  }, []);




  useEffect(() => {
    if (!isPlaying || testimonials.length === 0) return;

    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [isPlaying, testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  // Fonction pour rendre les étoiles selon la note
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <svg
        key={i}
        className={`w-4 h-4 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  if (loading) {
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-1/3 mx-auto mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mb-8"></div>
            <div className="h-64 bg-gray-200 rounded-xl"></div>
          </div>
        </div>
      </section>
    );
  }

  if (testimonials.length === 0) {
    return null;
  }

  const current = testimonials[currentTestimonial];

  if (!current) {
    return null;
  }

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Témoignages Clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ne nous croyez pas sur parole - écoutez les professionnels du recrutement qui ont transformé leurs processus avec Jobrise
          </p>
        </div>

        {/* Main Testimonial */}
        <div className="relative max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className=" gap-0">
              {/* Content Side */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                {/* Quote Icon */}
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r ${current.color} mb-8`}>
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
                  </svg>
                </div>

                {/* Quote */}
                <blockquote className="text-xl lg:text-2xl text-gray-800 leading-relaxed mb-8 font-medium">
                  « {current.quote} »
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center mb-6">
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4 ${
                    current.isPhoto
                      ? 'bg-gray-200'
                      : `bg-gradient-to-r ${current.color}`
                  }`}>
                    {current.isPhoto ? (
                      <img
                        src={current.avatar}
                        alt={current.author}
                        className="w-16 h-16 rounded-full object-cover"
                      />
                    ) : (
                      current.avatar
                    )}
                  </div>
                  <div>
                    <div className="text-lg font-semibold text-gray-900">{current.author}</div>
                    <div className="text-gray-600">{current.position}</div>
                    <div className={`text-sm font-medium bg-gradient-to-r ${current.color} bg-clip-text text-transparent`}>
                      {current.company}
                    </div>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center mb-8">
                  <div className="flex mr-2">
                    {renderStars(current.rating)}
                  </div>
                  <span className="text-sm text-gray-600 ml-2">
                    {current.rating}/5 étoiles
                  </span>
                </div>

                {/* Navigation Controls */}
                <div className="flex items-center justify-between">
                  <div className="flex space-x-2">
                    {testimonials.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => goToTestimonial(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          currentTestimonial === index
                            ? 'w-8 bg-blue-600'
                            : 'bg-gray-300 hover:bg-gray-400'
                        }`}
                      />
                    ))}
                  </div>
                  
                  <div className="flex space-x-2">
                    <button
                      onClick={prevTestimonial}
                      className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                    >
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                      </svg>
                    </button>
                    <button
                      onClick={() => setIsPlaying(!isPlaying)}
                      className={`p-2 rounded-full transition-colors ${
                        isPlaying ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'
                      }`}
                    >
                      {isPlaying ? (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                        </svg>
                      ) : (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      )}
                    </button>
                    <button
                      onClick={nextTestimonial}
                      className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                    >
                      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>

        {/* Additional Testimonials Preview */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {testimonials.filter((_, index) => index !== currentTestimonial).slice(0, 3).map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-105"
              onClick={() => goToTestimonial(testimonials.indexOf(testimonial))}
            >
              <div className="flex items-center mb-4">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold mr-3 ${
                  testimonial.isPhoto
                    ? 'bg-gray-200'
                    : `bg-gradient-to-r ${testimonial.color}`
                }`}>
                  {testimonial.isPhoto ? (
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.author}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                  ) : (
                    testimonial.avatar
                  )}
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.author}</div>
                  <div className="text-gray-600 text-xs">{testimonial.company}</div>
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed line-clamp-3">
                « {testimonial.quote.substring(0, 120)}... »
              </p>
              <div className="mt-4 flex justify-between items-center">
                <div className="flex">
                  {renderStars(testimonial.rating)}
                </div>
                <span className="text-xs text-gray-500">Lire plus →</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Prêt à Rejoindre Ces Success Stories ?</h3>
            <div className=' mb-6'>
              <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Commencez votre parcours vers l'excellence en recrutement avec notre tableau de bord KPI complet
            </p>
            </div>
            <Link to='/contact' className='no-underline'>
            <div className="flex flex-col sm:flex-row gap-4 justify-center ">
              <button className="border-2 border-white/30 text-white px-8 py-3 rounded-xl font-semibold hover:bg-white/10 transition-all ">
                Planifier une Démo
              </button>
            </div>
            </Link>
            
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fillBar {
          from {
            width: 0%;
          }
          to {
            width: var(--final-width);
          }
        }
        
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default TestimonialsCarousel;